export const prescript_documents = [
  {
    id: 1,
    name: "MFMA",
    summary: "shortsummary/MFMA.html",
    link: "MFMA.pdf",
    audio_en: "audio/en/MFMA_en.mp3",
    audio_af: "audio/af/MFMA_af.mp3",
    audio_xh: "audio/xh/MFMA_xh.mp3"
  },
  {
    id: 2,
    name: "PFMA",
    summary: "shortsummary/PFMA.html",
    link: "PFMA.pdf",
    audio_en: "audio/en/PFMA_en.mp3",
    audio_af: "audio/af/PFMA_af.mp3",
    audio_xh: "audio/xh/PFMA_xh.mp3"
  },
  {
    id: 3,
    name: "NIP 2050",
    summary: "shortsummary/NIP 2050.html",
    link: "NIP 2050.pdf",
    audio_en: "audio/en/NIP 2050_en.mp3",
    audio_af: "audio/af/NIP 2050_af.mp3",
    audio_xh: "audio/xh/NIP 2050_xh.mp3"
  },
  {
    id: 4,
    name: "SPLUMA",
    summary: "shortsummary/SPLUMA.html",
    link: "SPLUMA.pdf",
    audio_en: "audio/en/SPLUMA_en.mp3",
    audio_af: "audio/af/SPLUMA_af.mp3",
    audio_xh: "audio/xh/SPLUMA_xh.mp3"
  },
  {
    id: 5,
    name: "PSP_western_cape_strategic_plan_2019-2024 (PSP)",
    summary: "shortsummary/western_cape_strategic_plan_2019-2024 (PSP).html",
    link: "PSP_western_cape_strategic_plan_2019-2024 (PSP).pdf",
    audio_en: "audio/en/PSP_western_cape_strategic_plan_2019-2024_(PSP)_en.mp3",
    audio_af: "audio/af/PSP_western_cape_strategic_plan_2019-2024_(PSP)_af.mp3",
    audio_xh: "audio/xh/PSP_western_cape_strategic_plan_2019-2024_(PSP)_xh.mp3"
  },
  {
    id: 6,
    name: "Growth-for-Jobs-Strategy-2023-Cabinet-Approved",
    summary: "shortsummary/Growth-for-Jobs-Strategy-2023-Cabinet-Approved.html",
    link: "Growth-for-Jobs-Strategy-2023-Cabinet-Approved.pdf",
    audio_en: "audio/en/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_en.mp3",
    audio_af: "audio/af/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_af.mp3",
    audio_xh: "audio/xh/Growth-for-Jobs-Strategy-2023-Cabinet-Approved_xh.mp3"
  }
];